module.exports = __webpack_public_path__ + "location-block.png?baa0d33ce310c909d11d7e72e2057f98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/location-block.png
// module id = 997
// module chunks = 0